import {remoteForm} from '@github-ui/remote-form'

remoteForm('.js-saved-reply-delete', async function (form, wants) {
  await wants.text()

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const container = form.closest('.js-saved-reply-container')!
  const count = container.querySelectorAll('.js-saved-reply-list-item').length

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const list = container.querySelector<HTMLElement>('.js-saved-reply-list')!
  list.hidden = count <= 1 ? true : false

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const emptyContainer = container.querySelector<HTMLElement>('.js-saved-reply-empty-container')!
  if (count === 1) emptyContainer.hidden = false

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const item = form.closest('.js-saved-reply-list-item')!
  item.remove()
})
